import { ServerAlertAction } from '../../common'
import { ContentAction } from '../types/ContentAction';


let showMsg = (msg: string, vari: any) => {

    let showAlert = (message: string, variant: 'error' | 'success' = 'error'): ServerAlertAction => ({
        type: 'SHOW_ALERT', data: { message: message, variant: variant, openSnackbar: true }
    })
    return (dispatch: any) => {
        dispatch(showAlert(msg, vari));
    }
}

const assignTest = (data: any) => (dispatch: any) => {
    const update = (data: any): ContentAction =>
      ({ type: 'ASSIGN_TEST', data });
      dispatch(update(data))
  }


export {
    showMsg,
    assignTest
}